<template>
  <div>
    <div class="modal-pdv show" id="modalEditar" tabindex="-1" v-if="modal">
      <div class="modal-pdv-content pt-3">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group mb-2">
                <label class="mb-0 small font-weight-bold">Tipo da Venda</label>
                <select class="form-control" v-model="dados.tipo_comanda" :disabled="dados.tipo_comanda === '4'">
                  <option value="1">Mesa</option>
                  <option value="2">Delivery</option>
                  <option value="3">Comanda</option>
                  <option value="5">Balcão</option>
                  <option value="4" :disabled="dados.tipo_comanda !== '4'">Venda Rápida</option>
                </select>
              </div>
              <div class="row no-gutters" v-if="['1','3'].includes(dados.tipo_comanda)">
                <div class="col-6 pr-1" v-if="['1','3'].includes(dados.tipo_comanda)">
                  <div class="form-group mb-2">
                    <label class="mb-0 small font-weight-bold">Mesa:</label>
                    <input type="number" class="form-control" v-model="dados.mesa" placeholder="Nº da mesa"/>
                  </div>
                </div>
                <div class="col-6 pl-1">
                  <div class="form-group mb-2">
                    <label class="mb-0 small font-weight-bold">Comanda</label>
                    <input type="number" class="form-control" placeholder="Ex: 123" v-model="dados.ref_comanda"/>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group mb-2">
                    <label class="mb-0 small font-weight-bold">Qtd de pessoas</label>
                    <div class="d-flex">
                      <input type="number" class="form-control mr-2" v-model="dados.qtd_pessoas" @change="changeQtdPessoas(null)" placeholder="Quantidade" min="1" max="256"/>
                      <div class="text-nowrap">
                        <button class="btn btn-primary mr-1" @click="changeQtdPessoas(-1)" style="width: 52px">
                          <i class="fa fa-minus"></i>
                        </button>
                        <button class="btn btn-primary" @click="changeQtdPessoas(1)" style="width: 52px">
                          <i class="fa fa-plus"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group mb-2" v-if="usuario.id_funcao < 3 && dados.status === '2'">
                <label class="mb-0 small font-weight-bold">Data da venda</label>
                <input type="datetime-local" min="0" class="form-control" v-model="dados.created"/>
              </div>
              <div class="form-group mb-0">
                <label class="mb-0 small font-weight-bold">Observações</label>
                <textarea class="form-control" placeholder="Observações da venda" v-model="dados.observacao" style="resize: none" rows="2"></textarea>
              </div>
            </div>
            <div class="col-md-6">
              <hr class="d-md-none">
              <div class="mb-2">
                <div class="btn border btn-block text-left mb-3 py-3" v-if="dados.id_cliente">
                  <div class="d-flex justify-content-between align-items-center">
                    <h6 class="m-0">{{dados.cliente.nome_cliente}}</h6>
                    <div class="text-right text-nowrap" style="width: 170px">
                      <a v-if="dados.id_cliente" class="btn btn-third mr-2" href="javascript:" style="width: 50px" @click="buscarClientes(dados.id_cliente)">
                        <i class="fa fa-user-edit"></i>
                      </a>
                      <a v-if="dados.id_cliente" class="btn btn-secondary" href="javascript:" style="width: 50px" @click="solicitarRemoverCliente">
                        <i class="fa fa-times"></i>
                      </a>
                    </div>
                  </div>
                  <hr class="mb-2">
                  <div v-if="dados.cliente.telefone">
                    <b>Telefone:</b> <span>{{dados.cliente.telefone | phone}}</span>
                  </div>
                  <div v-if="dados.cliente.endereco">
                    <b>Endereço: </b>
                    {{dados.cliente.endereco}}<span v-if="dados.cliente.numero">, {{dados.cliente.numero}}</span><span v-if="dados.cliente.bairro">, {{dados.cliente.bairro}}</span><span v-if="dados.cliente.cep">, {{dados.cliente.cep}}</span><span v-if="dados.cliente.nome_cidade">, {{dados.cliente.nome_cidade}} - {{dados.cliente.sigla_estado}}</span>
                  </div>
                </div>
                <button v-if="!dados.id_cliente" class="btn btn-info btn-block py-2 text-left" type="button" @click="buscarClientes(null)">
                  <i class="fa fa-user-plus"></i>
                  <span class="d-block small">Adicionar Cliente</span>
                </button>
              </div>
              <div class="mb-2" v-if="dados.status === '2'">
                <a class="btn btn-third py-2 btn-block text-left" href="javascript:" @click="reabrirVenda()">
                  <i class="fa fa-edit"></i>
                  <div class="small">Reabrir Venda</div>
                </a>
              </div>
              <div class="mb-2" v-if="dados.status !== '3'">
                <a class="btn btn-secondary py-2 btn-block text-left" href="javascript:" @click="cancelarVenda()">
                  <i class="fa fa-trash-alt"></i>
                  <div class="small">Cancelar Venda</div>
                </a>
              </div>
              <div v-if="dados.id_nfe">
                <a class="btn btn-warning py-2 btn-block text-left" href="javascript:" target="_blank" @click="cancelarNota()">
                  <i class="fa fa-file-invoice"></i>
                  <div class="small">Cancelar Cupom Fiscal</div>
                </a>
              </div>
              <div class="small mt-3 mb-2 mb-md-0 font-weight-bold" v-if="dados.id_comanda">
                <i class="fa fa-qrcode mr-1 text-secondary"></i> ID LeCard: {{ dados.id_comanda }}
              </div>
            </div>
          </div>
        </div>
        <div class="modal-content-footer bg-light border-top p-2 mt-3 d-flex justify-content-between">
          <button class="btn btn-dark p-3" @click="toggleModal(false)">
            <i class="fa fa-chevron-left mr-2"></i>
            Voltar
          </button>
          <button class="btn btn-success p-3" @click="editarComanda()" :disabled="dados.status === '3'">
            <i class="fa fa-check mr-2"></i>
            Salvar
          </button>
        </div>
      </div>
    </div>

    <cliente ref="editCliente" @remover="removerCliente" @retorno="inserirCliente"/>
  </div>
</template>

<script>
  export default {
    name: "editarComanda",
    data() {
      return {
        modal: false,
        token: localStorage.getItem('key'),
        editarCliente: false,
        dados: {
          status: '1',
          ref_comanda: '',
          mesa: "",
          observacao: "",
          tipo_comanda: '1',
          id_cliente: null
        },

        cliente: {}
      }
    },

    methods: {
      toggleModal(m) {
        this.modal = m;
        this.$nextTick(() => {
          this.$helpers.toggleModal(m, 'modalEditar', this.toggleModal);

          if (m === 1) {
            this.$helpers.focusElement('btnEdtMesa');
          }
        })
      },

      inserirCliente(dados) {
        if (dados) {
          this.dados.id_cliente = dados.id_cliente;
          this.dados.cliente = dados;
        }

        if (!this.editarCliente) {
          this.toggleModal(1);

        } else if (dados) {
          this.editarComanda();
        }
      },

      buscarClientes(id) {
        this.$refs.editCliente.iniciar(id);
      },

      solicitarRemoverCliente() {
        this.$swal({
          text: 'Deseja realmente remover este cliente desta venda?',
          buttons: ['Não', 'Sim'],
          dangerMode: true
        }).then(res => {
          if (res) {
            this.removerCliente();
          }
        })
      },

      removerCliente() {
        this.dados.id_cliente = null;
        this.dados.cliente = {};
        this.editarComanda();
      },

      editarComanda() {
        if (!this.dados.id_comanda) {
          this.toggleModal(false);
          this.$emit('editarVenda', this.dados);
          return;
        }

        switch (this.dados.tipo_comanda) {
          case '1':
            if (isNaN(this.dados.mesa) || this.dados.mesa <= 0) {
              this.$swal("Antenção!", "Selecione uma mesa.");
              return
            }
            break;

          case '3':
            if (!this.dados.ref_comanda || !this.dados.ref_comanda.trim()) {
              this.$swal("Antenção!", "Informe o código da comanda.");
              return
            }
            break;

          default:
            this.dados.mesa = null;
            this.dados.ref_comanda = null;
            break;
        }

        if (this.dados.status === '2') {
          this.$helpers.confirmarSenhaAdm(this, this.processarEdicao);

        } else {
          this.processarEdicao();
        }
      },

      processarEdicao() {
        this.$store.state.load = true;
        this.$http.post('comandas/editar/' + this.token, this.dados)
          .then(() => {
            this.$store.state.load = false;
            this.$emit('atualizarComanda');
            this.toggleModal(false);

          }, res => {
            this.$store.state.load = false;
            this.$swal(res.data.msg ? res.data.msg : 'Erro temporário');
            console.log(res);
          });
      },

      reabrirVenda() {
        this.$helpers.confirmarSenhaAdm(this, () => {
          this.$swal({
            title: '',
            text: 'Deseja realmente reabrir esta venda?',
            buttons: ['Não','Sim'],
            dangerMode: true
          }).then((r) => {
            if (r) {
              this.$store.state.load = true;
              this.$http.post('comandas/reabrir/' + this.token, { id_comanda: this.dados.id_comanda })
                .then((res) => {
                  this.$store.state.load = false;
                  res.data = res.data || {};

                  if (res.data.success) {
                    this.$emit('atualizarComanda');
                    this.toggleModal(false);

                  } else {
                    this.$swal(res.data.msg || 'Erro temporário');
                  }

                }, res => {
                  this.$store.state.load = false;
                  this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
                });
            }
          });
        });
      },

      cancelarVenda() {
        this.$helpers.confirmarSenhaAdm(this, () => {
          this.$swal({
            title: '',
            text: 'Deseja realmente cancelar esta venda?',
            buttons: ['Não','Sim'],
            dangerMode: true
          }).then((r) => {
            if (r) {
              this.$store.state.load = true;
              this.$http.post('comandas/remover/' + this.token, { id_comanda: this.dados.id_comanda })
                .then((res) => {
                  this.$store.state.load = false;
                  res.data = res.data || {};

                  if (res.data.success) {
                    this.$swal('Venda cancelada com sucesso.');
                    this.$emit('atualizarComanda');
                    this.toggleModal(false);

                  } else {
                    this.$swal(res.data.msg || 'Erro temporário');
                  }

                }, res => {
                  this.$store.state.load = false;
                  this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
                });
            }
          });
        });
      },

      cancelarNota() {
        this.$swal({
          text: 'Por favor informe o motivo:',
          content: {
            element: "input",
            attributes: {
              placeholder: "Motivo (obrigatório no mínimo 10 caracteres)",
              type: "text",
              className: 'form-control'
            }
          },
          buttons: ['Voltar','Enviar'],
        }).then(justificativa => {
          if (justificativa) {
            if (justificativa.length > 9) {
              this.$store.state.load = "Por favor aguarde..";
              // const url = dados.modelo === '59' ? 'fiscal/sat/cancelar/' : 'fiscal/nfce/cancelar/';
              this.$http.post('fiscal/nfce/cancelar/' + this.token, { id_nfe: this.dados.id_nfe, justificativa })
                .then(res => {
                  this.$store.state.load = false;

                  if (res.data && res.data.success) {
                    this.$swal("Cupom cancelado com sucesso! Por favor imprima a via de cancelamento.");
                    this.$emit('atualizarComanda');

                  } else {
                    this.$swal("Não foi possível cancelar este Cupom");
                  }

                }, res => {
                  this.$store.state.load = false;
                  this.$swal(res.data.msg || 'Não foi possível cancelar este Cupom');
                });

            } else {
              this.$swal("A justificativa precisa ter no mínimo 10 caracteres").then(() => {
                this.cancelarNota();
              });
            }
          }
        });
      },

      changeQtdPessoas(qtd) {
        if (qtd) {
          let qtd_p = parseInt(this.dados.qtd_pessoas || '1');

          if ((qtd_p + qtd) > 0) {
            this.dados.qtd_pessoas = qtd_p + qtd;
          }

        } else if (isNaN(this.dados.qtd_pessoas) || parseInt(this.dados.qtd_pessoas) < 1) {
          this.dados.qtd_pessoas = 1;

        } else if (parseInt(this.qtd_pessoas) > 256) {
          this.dados.qtd_pessoas = 256;
        }
      },

      selEditarComanda(dados, editarCliente) {
        this.editarCliente = editarCliente || false;
        this.dados = {
          id_comanda: dados.id_comanda || null,
          status: dados.status,
          ref_comanda: dados.ref_comanda,
          mesa: dados.mesa,
          observacao: dados.observacao,
          qtd_pessoas: dados.qtd_pessoas,
          tipo_comanda: dados.tipo_comanda,
          id_cliente: dados.id_cliente,
          cliente: dados.cliente,
          id_nfe: dados.id_nfe,
          created: dados.created
        };

        if (editarCliente) {
          this.buscarClientes(dados.id_cliente || null);

        } else {
          this.toggleModal(1);
        }
      }
    },

    computed: {
      usuario() {
        return this.$store.state.dataUser
      }
    }
  }
</script>

<style scoped>

</style>
